import { Link } from 'react-router-dom';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';

export default function AccessDeniedPage() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <ShieldExclamationIcon className="h-24 w-24 text-red-500" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          Accès Refusé
        </h1>
        
        <p className="text-gray-600 mb-6">
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
        </p>
        
        <div className="space-y-3">
          <Link
            to="/"
            className="block w-full bg-purple-600 text-white px-6 py-3 rounded-md hover:bg-purple-700 transition font-medium"
          >
            Retour à l'accueil
          </Link>
          
          <p className="text-sm text-gray-500">
            Si vous pensez qu'il s'agit d'une erreur, contactez l'administrateur de votre hôtel.
          </p>
        </div>
      </div>
    </div>
  );
}
